import * as yup from "yup";
import { Strong_Password } from "./ValidationFunctions";

export const validationSchema = yup.object().shape({
  password: yup
    .string()
    .required("پسورد را وارد کنید")
    .matches(
      Strong_Password,
      "پسورد حداقل 8 کاراکتر و شامل حروف کوچک،بزرگ،اعداد  و (@،!،%،..)است"
    ),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), null], "پسورد اشتباه است")
    .required("پسورد را مجددا وارد کنید"),
});

export const initialValues = {
  password: "",
  confirm_password: "",
};
